import { PageController } from '@client/components/_core/layout/PageController';
import { RegisterBuilderDrawer } from '@client/components/registers/RegisterBuilderDrawer';
import { usePermissions } from '@client/hooks/auth/usePermissions';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useRef } from 'react';

export const Route = createFileRoute('/console/$orgId/compliance/registers/_list/new')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Build a register',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { orgId } = Route.useParams();
    const navigate = useNavigate();
    const { can } = usePermissions();
    // A successful create navigates to the new register while the drawer is still closing; the close
    // must not then navigate back to the list over the top of it.
    const createdRef = useRef(false);

    if (!can('register:update')) {
        return <Navigate to="/console/$orgId/compliance/registers" params={{ orgId }} replace />;
    }

    return (
        <PageController route={Route}>
            <RegisterBuilderDrawer
                open
                onClose={() => {
                    if (!createdRef.current) navigate({ moveInMatches: -1 });
                }}
                onCreated={(registerId) => {
                    createdRef.current = true;
                    void navigate({
                        to: '/console/$orgId/compliance/registers/$registerId',
                        params: { orgId, registerId },
                    });
                }}
            />
        </PageController>
    );
}
